import React, { PropsWithChildren } from 'react';
import { NativeProps } from '@/src/components/interfaces';
import classNames from 'classnames';
import FeatherIcon from 'feather-icons-react';

export enum CIcons {
  Activity = 'activity',
  Airplay = 'airplay',
  AlertCircle = 'alert-circle',
  AlertOctagon = 'alert-octagon',
  AlertTriangle = 'alert-triangle',
  AlignCenter = 'align-center',
  AlignJustify = 'align-justify',
  AlignLeft = 'align-left',
  AlignRight = 'align-right',
  Anchor = 'anchor',
  Aperture = 'aperture',
  Archive = 'archive',
  ArrowDown = 'arrow-down',
  ArrowDownCircle = 'arrow-down-circle',
  ArrowDownLeft = 'arrow-down-left',
  ArrowDownRight = 'arrow-down-right',
  ArrowLeft = 'arrow-left',
  ArrowLeftCircle = 'arrow-left-circle',
  ArrowRight = 'arrow-right',
  ArrowRightCircle = 'arrow-right-circle',
  ArrowUp = 'arrow-up',
  ArrowUpCircle = 'arrow-up-circle',
  ArrowUpLeft = 'arrow-up-left',
  ArrowUpRight = 'arrow-up-right',
  AtSign = 'at-sign',
  Award = 'award',
  BarChart = 'bar-chart',
  BarChart2 = 'bar-chart-2',
  Battery = 'battery',
  BatteryCharging = 'battery-charging',
  Bell = 'bell',
  BellOff = 'bell-off',
  Bluetooth = 'bluetooth',
  Bold = 'bold',
  Book = 'book',
  BookOpen = 'book-open',
  Bookmark = 'bookmark',
  Box = 'box',
  Briefcase = 'briefcase',
  Calendar = 'calendar',
  Camera = 'camera',
  CameraOff = 'camera-off',
  Cast = 'cast',
  Check = 'check',
  CheckCircle = 'check-circle',
  CheckSquare = 'check-square',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  ChevronsDown = 'chevrons-down',
  ChevronsLeft = 'chevrons-left',
  ChevronsRight = 'chevrons-right',
  ChevronsUp = 'chevrons-up',
  Chrome = 'chrome',
  Circle = 'circle',
  Clipboard = 'clipboard',
  Clock = 'clock',
  Cloud = 'cloud',
  CloudDrizzle = 'cloud-drizzle',
  CloudLightning = 'cloud-lightning',
  CloudOff = 'cloud-off',
  CloudRain = 'cloud-rain',
  CloudSnow = 'cloud-snow',
  Code = 'code',
  Codepen = 'codepen',
  Codesandbox = 'codesandbox',
  Coffee = 'coffee',
  Columns = 'columns',
  Command = 'command',
  Compass = 'compass',
  Copy = 'copy',
  CornerDownLeft = 'corner-down-left',
  CornerDownRight = 'corner-down-right',
  CornerLeftDown = 'corner-left-down',
  CornerLeftUp = 'corner-left-up',
  CornerRightDown = 'corner-right-down',
  CornerRightUp = 'corner-right-up',
  CornerUpLeft = 'corner-up-left',
  CornerUpRight = 'corner-up-right',
  Cpu = 'cpu',
  CreditCard = 'credit-card',
  Crop = 'crop',
  Crosshair = 'crosshair',
  Database = 'database',
  Delete = 'delete',
  Disc = 'disc',
  Divide = 'divide',
  DivideCircle = 'divide-circle',
  DivideSquare = 'divide-square',
  DollarSign = 'dollar-sign',
  Download = 'download',
  DownloadCloud = 'download-cloud',
  Dribbble = 'dribbble',
  Droplet = 'droplet',
  Edit = 'edit',
  Edit2 = 'edit-2',
  Edit3 = 'edit-3',
  ExternalLink = 'external-link',
  Eye = 'eye',
  EyeOff = 'eye-off',
  Facebook = 'facebook',
  FastForward = 'fast-forward',
  Feather = 'feather',
  Figma = 'figma',
  File = 'file',
  FileMinus = 'file-minus',
  FilePlus = 'file-plus',
  FileText = 'file-text',
  Film = 'film',
  Filter = 'filter',
  Flag = 'flag',
  Folder = 'folder',
  FolderMinus = 'folder-minus',
  FolderPlus = 'folder-plus',
  Framer = 'framer',
  Frown = 'frown',
  Gift = 'gift',
  GitBranch = 'git-branch',
  GitCommit = 'git-commit',
  GitMerge = 'git-merge',
  GitPullRequest = 'git-pull-request',
  Github = 'github',
  Gitlab = 'gitlab',
  Globe = 'globe',
  Grid = 'grid',
  HardDrive = 'hard-drive',
  Hash = 'hash',
  Headphones = 'headphones',
  Heart = 'heart',
  HelpCircle = 'help-circle',
  Hexagon = 'hexagon',
  Home = 'home',
  Image = 'image',
  Inbox = 'inbox',
  Info = 'info',
  Instagram = 'instagram',
  Italic = 'italic',
  Key = 'key',
  Layers = 'layers',
  Layout = 'layout',
  LifeBuoy = 'life-buoy',
  Link = 'link',
  Link2 = 'link-2',
  Linkedin = 'linkedin',
  List = 'list',
  Loader = 'loader',
  Lock = 'lock',
  LogIn = 'log-in',
  LogOut = 'log-out',
  Mail = 'mail',
  Map = 'map',
  MapPin = 'map-pin',
  Maximize = 'maximize',
  Maximize2 = 'maximize-2',
  Meh = 'meh',
  Menu = 'menu',
  MessageCircle = 'message-circle',
  MessageSquare = 'message-square',
  Mic = 'mic',
  MicOff = 'mic-off',
  Minimize = 'minimize',
  Minimize2 = 'minimize-2',
  Minus = 'minus',
  MinusCircle = 'minus-circle',
  MinusSquare = 'minus-square',
  Monitor = 'monitor',
  Moon = 'moon',
  MoreHorizontal = 'more-horizontal',
  MoreVertical = 'more-vertical',
  MousePointer = 'mouse-pointer',
  Move = 'move',
  Music = 'music',
  Navigation = 'navigation',
  Navigation2 = 'navigation-2',
  Octagon = 'octagon',
  Package = 'package',
  Paperclip = 'paperclip',
  Pause = 'pause',
  PauseCircle = 'pause-circle',
  PenTool = 'pen-tool',
  Percent = 'percent',
  Phone = 'phone',
  PhoneCall = 'phone-call',
  PhoneForwarded = 'phone-forwarded',
  PhoneIncoming = 'phone-incoming',
  PhoneMissed = 'phone-missed',
  PhoneOff = 'phone-off',
  PhoneOutgoing = 'phone-outgoing',
  PieChart = 'pie-chart',
  Play = 'play',
  PlayCircle = 'play-circle',
  Plus = 'plus',
  PlusCircle = 'plus-circle',
  PlusSquare = 'plus-square',
  Pocket = 'pocket',
  Power = 'power',
  Printer = 'printer',
  Radio = 'radio',
  RefreshCcw = 'refresh-ccw',
  RefreshCw = 'refresh-cw',
  Repeat = 'repeat',
  Rewind = 'rewind',
  RotateCcw = 'rotate-ccw',
  RotateCw = 'rotate-cw',
  Rss = 'rss',
  Save = 'save',
  Scissors = 'scissors',
  Search = 'search',
  Send = 'send',
  Server = 'server',
  Settings = 'settings',
  Share = 'share',
  Share2 = 'share-2',
  Shield = 'shield',
  ShieldOff = 'shield-off',
  ShoppingBag = 'shopping-bag',
  ShoppingCart = 'shopping-cart',
  Shuffle = 'shuffle',
  Sidebar = 'sidebar',
  SkipBack = 'skip-back',
  SkipForward = 'skip-forward',
  Slack = 'slack',
  Slash = 'slash',
  Sliders = 'sliders',
  Smartphone = 'smartphone',
  Smile = 'smile',
  Speaker = 'speaker',
  Square = 'square',
  Star = 'star',
  StopCircle = 'stop-circle',
  Sun = 'sun',
  Sunrise = 'sunrise',
  Sunset = 'sunset',
  Table = 'table',
  Tablet = 'tablet',
  Tag = 'tag',
  Target = 'target',
  Terminal = 'terminal',
  Thermometer = 'thermometer',
  ThumbsDown = 'thumbs-down',
  ThumbsUp = 'thumbs-up',
  ToggleLeft = 'toggle-left',
  ToggleRight = 'toggle-right',
  Tool = 'tool',
  Trash = 'trash',
  Trash2 = 'trash-2',
  Trello = 'trello',
  TrendingDown = 'trending-down',
  TrendingUp = 'trending-up',
  Triangle = 'triangle',
  Truck = 'truck',
  Tv = 'tv',
  Twitch = 'twitch',
  Twitter = 'twitter',
  Type = 'type',
  Umbrella = 'umbrella',
  Underline = 'underline',
  Unlock = 'unlock',
  Upload = 'upload',
  UploadCloud = 'upload-cloud',
  User = 'user',
  UserCheck = 'user-check',
  UserMinus = 'user-minus',
  UserPlus = 'user-plus',
  UserX = 'user-x',
  Users = 'users',
  Video = 'video',
  VideoOff = 'video-off',
  Voicemail = 'voicemail',
  Volume = 'volume',
  Volume1 = 'volume-1',
  Volume2 = 'volume-2',
  VolumeX = 'volume-x',
  Watch = 'watch',
  Wifi = 'wifi',
  WifiOff = 'wifi-off',
  Wind = 'wind',
  X = 'x',
  XCircle = 'x-circle',
  XOctagon = 'x-octagon',
  XSquare = 'x-square',
  Youtube = 'youtube',
  Zap = 'zap',
  ZapOff = 'zap-off',
  ZoomIn = 'zoom-in',
  ZoomOut = 'zoom-out',
}

export enum CIconColor {
  Inherit = 'inherit',
  Disabled = 'disabled',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Primary = 'primary',
  Black = 'black',
  White = 'white',
  Gray1 = 'gray-1',
  Gray2 = 'gray-2',
  Gray3 = 'gray-3',
  Gray4 = 'gray-4',
  Gray5 = 'gray-5',
  Gray6 = 'gray-6',
  Gray7 = 'gray-7',
  Gray8 = 'gray-8',
  Gray9 = 'gray-9',
}

export enum CIconSize {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  H3 = 'h3',
  H2 = 'h2',
  H1 = 'h1',
}

export interface CIconProps extends NativeProps {
  icon: CIcons;
  color?: CIconColor | string;
  size?: CIconSize;
}

export function CIcon(props: PropsWithChildren<CIconProps>): React.JSX.Element {
  const size = props.size ?? CIconSize.Md;

  return (
    <i onClick={props.onClick}>
      <FeatherIcon
        icon={props.icon}
        className={classNames('c-icon', `c-icon--size-${size}`, {
          [`c-icon--color-${props.color}`]: props.color,
        }, props.class, 'no-select')}
      />
    </i>
  );
}